import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { api, authStore } from './api';

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(authStore.user);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!authStore.token) { setLoading(false); return; }
    try {
      const { data } = await api.get('/auth/me');
      setUser(data.user);
      authStore.user = data.user;
      // Capture timezone once per session (idempotent server-side)
      try {
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const offsetMin = -new Date().getTimezoneOffset(); // east of UTC = positive
        if (tz) {
          await api.put('/auth/profile/timezone', {
            tz_name: tz, tz_offset_minutes: offsetMin,
          }).catch(() => {});
        }
      } catch { /* ignore */ }
    } catch {
      authStore.clear();
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post('/auth/login', { email, password });
    authStore.token = data.token;
    authStore.user = data.user;
    setUser(data.user);
    return data.user;
  };
  const register = async (payload) => {
    const { data } = await api.post('/auth/register', payload);
    authStore.token = data.token;
    authStore.user = data.user;
    setUser(data.user);
    return data.user;
  };
  const logout = () => { authStore.clear(); setUser(null); };
  const setSession = (token, u) => {
    authStore.token = token;
    authStore.user = u;
    setUser(u);
  };

  return (
    <AuthCtx.Provider value={{ user, setUser, setSession, login, register, logout, loading, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
